module.exports = __webpack_public_path__ + "img/claims.ca074907.jpeg";